import './styles.scss'

import { useTranslation } from 'react-i18next'

import A11yButton from '@/components/A11yButton'
import ImageWithFallBack from '@/components/ImageWithFallback'
import { SHOP_CATEGORY_TYPE } from '@/libs/constants'

interface SuggestionCategoryItemProps {
  categoryId: string | number
  categoryName?: string
  type: string
  menuImages: {
    type: string
    url: string
  }[]
  onClick: (categoryId: string | number, type: string) => void
}

const SuggestionCategoryItem = ({
  categoryId,
  categoryName = '',
  type,
  menuImages,
  onClick,
}: SuggestionCategoryItemProps) => {
  const { t } = useTranslation()

  const getCategoryImage = (arrayData) => {
    const selectedImage = arrayData.find((item) => item.type === 'thumb')
    return selectedImage?.url
  }

  return (
    <A11yButton
      elementType="div"
      className="search__dropdown__product-categories__category-item__wrapper"
      onClick={() => onClick(categoryId, type)}
      onKeyDown={(e) => e.preventDefault()}
    >
      <div className="search__dropdown__product-categories__category-item__left">
        <ImageWithFallBack
          alt={categoryName}
          className="search__dropdown__product-categories__category-item__left__image"
          src={type === SHOP_CATEGORY_TYPE.MACHINES
            ? getCategoryImage(menuImages)
            : menuImages[0].url}
        />
      </div>
      <div className="search__dropdown__product-categories__category-item__right">
        <div className="search__dropdown__product-categories__category-item__right__name">
          {t(categoryName)}
        </div>
      </div>
    </A11yButton>
  )
}

export default SuggestionCategoryItem
